import { defineMessages } from 'react-intl';

export default defineMessages({
  // Flags
  cancelAccountDeletionFlagErrorTitle: {
    id: 'cancel.account.deletion.flag.error.title',
    defaultMessage: 'Something went wrong.',
    description: '',
  },
  cancelAccountDeletionFlagErrorDesc: {
    id: 'cancel.account.deletion.flag.error.description',
    defaultMessage: 'Please try again later.',
    description: '',
  },
  headTitle: {
    id: 'cancel.account.deletion.title',
    defaultMessage: 'Cancel the deletion of your account',
    description: '',
  },

  cancelAccountDeletionSignupMessage: {
    id: 'cancel.account.deletion.signup',
    defaultMessage: 'Sign up for a new account',
    description: 'Button text for signing up for a new account',
  },
  cancelAccountDeletionInfo: {
    id: 'cancel.account.deletion.info',
    defaultMessage:
      'Your account will be permanently deleted. You can cancel the deletion before {deleteOn}.',
    description: 'Deletion info in the text box',
  },
  cancelAccountDeletionButton: {
    id: 'cancel.account.deletion.button',
    defaultMessage: 'Cancel deletion',
    description: 'Text for cancel deletion button',
  },
  cancelAccountDeletionLogout: {
    id: 'cancel.account.deletion.log.out',
    defaultMessage: 'Log out (and delete your account as scheduled)',
    description: 'Text for log out button',
  },
});
